import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Go to dashboard ")

import { computed } from 'vue';

interface Props {
  loading?: boolean;
  current?: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    loading: { type: Boolean },
    current: { default: 0 }
  },
  emits: ['confirm'],
  setup(__props: any) {

const props = __props as { loading?: boolean, current: number }




const steps: Array<{ title: string; content: string }> = [
  {
    title: 'Approve Contract',
    content: `Proceed to press “Approve” at Metamask. It takes 2 - 3 minutes to process. Please do not visit this page.`,
  },
  {
    title: 'Confirm',
    content:
      'Donation is successful. It takes 15 - 20 minutes to generate NFT. You can check it on the management page.',
  },
];

const isGotoDisabled = computed(() => props.current < steps.length);

return (_ctx: any,_cache: any) => {
  const _component_BaseStep = _resolveComponent("BaseStep")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, index) => {
      return _createVNode(_component_BaseStep, _mergeProps(step, {
        key: step.content,
        completed: index < __props.current,
        loading: __props.loading && index === __props.current
      }), null, 16, ["completed", "loading"])
    }), 64)),
    _createVNode(_component_BaseButton, {
      full: "",
      "color-scheme": _unref(isGotoDisabled) ? undefined : 'primary',
      disabled: _unref(isGotoDisabled),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm'))),
      "data-testid": "donate-progress-dashboard"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["color-scheme", "disabled"])
  ], 64))
}
}

})